import React from 'react';
import './Teaching.css';
import img5 from '../Assets/teachingImg1.jpg'
import img6 from '../Assets/teachingImg2.jpg'
import img7 from '../Assets/teachingImg3.png'
import img8 from '../Assets/teachingImg4.jpg'

function Teaching() {
  return (
    <div className="teaching-container">
      <div className="teaching-hero">
        <h1>Educational Initiatives</h1>
        <p>Empowering Young Minds Through Quality Education</p>
      </div>
      
      <div className="teaching-content">

        <div className="teaching-section">
            <div className='teachingflexbox'>
                <div className='teachingTextbox'>
                <h2>Teaching & Educational Support</h2>
                <p>Volunteer Impact Initiative undertakes projects which focuses on providing educational support at local schools and community learning centers in Ghana.</p>
                <p>Volunteers play a vital role in enhancing the quality of education by assisting with teaching, tutoring, and classroom management, particularly in under-resourced areas.</p>
                <p>The initiative aims to empower students by improving their literacy, numeracy, and critical thinking skills. Volunteers will work alongside local teachers to deliver engaging lessons, foster a love for learning, and provide individualized attention to students who need extra support.</p>
                <p>Creativity, patience, and adaptability are highly valued, as volunteers are encouraged to bring their unique teaching methods and perspectives to create a dynamic and inclusive learning environment.</p>
                <p>Whether it's teaching English, mathematics, or arts, your contribution will make a significant impact on the educational journey of these young learners.</p>

                
                </div>


        </div>
    </div>

                <div className='teachingImgGrid'>
                    <img src={img5} alt='Volunteer teaching students in classroom' className='teachingImg'/>
                    <img src={img6} alt='Group learning activity with volunteers' className='teachingImg'/>
                    <img src={img7} alt='One-on-one tutoring session' className='teachingImg'/>
                    <img src={img8} alt='Creative arts lesson with students' className='teachingImg'/>
                </div>
        
      </div>
        <div className="call-to-action">
          <h2>Ready to Make a Difference?</h2>
          <p>Join our teaching initiative and help shape the future of Ghana's next generation</p>
          <a href='/VolunteerNow'><button className="cta-button">Apply to Teach</button></a>
        </div>
    </div>
  );
}

export default Teaching;